import { useState, useEffect } from 'react';

export default function Preloader() {
  const [show, setShow] = useState(true);
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    // Start fade out after 2.5 seconds
    const fadeTimer = setTimeout(() => {
      setOpacity(0);
    }, 2500);

    // Remove component after fade completes (3 seconds total)
    const removeTimer = setTimeout(() => {
      setShow(false);
    }, 3000);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  if (!show) return null;

  return (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-white"
      style={{
        opacity: opacity,
        transition: 'opacity 0.5s ease-out'
      }}
    >
      <div className="w-full max-w-[400px] p-8 flex items-center justify-center">
        <img
          src="https://pizzaveg.it/materiale/logo-pizzaveg-preloader.png"
          alt="PizzaVeg"
          className="w-full h-auto animate-pulse"
        />
      </div>
    </div>
  );
}